<template>
  <LayoutUser>
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <van-notice-bar
      left-icon="volume-o"
      text=" 欢迎使用城镇燃气追溯系统 "
    />
    <customer-info v-if="show" />
    <div class="image-container"></div>
    <div style="padding: 16px">
      <van-row class="btn-2" gutter="20">
        <van-col span="12">
          <van-button
            block
            type="primary"
            size="small"
            :loading="btnLoading && itemType === 'status'"
            :disabled="btnLoading && itemType === 'status'"
            loading-text="请稍后..."
            @click="handleAlarmStatusClick()"
          >报警器状态</van-button
          >
        </van-col>
        <van-col span="12">
          <van-badge
            style="width: 100%"
            :show-zero="false"
            :content="userData.unReadCount"
          >
            <van-button
              block
              type="primary"
              size="small"
              :loading="btnLoading && itemType === 'alarm'"
              :disabled="btnLoading && itemType === 'alarm'"
              loading-text="请稍后..."
              @click="handleAlarmAlarmClick()"
            >报警器告警</van-button
            >
          </van-badge>
        </van-col>
      </van-row>
    </div>
    <van-cell-group class="group" title=" ">
      <van-cell title="订单" to="/orderList" is-link />
      <van-cell title="钢瓶" to="/customerCylinder" is-link />
    </van-cell-group>
    <van-cell-group>
      <van-cell title="供应商名称" :value="userData.supplyName" />
      <van-cell title="上次送货人" :value="userData.deliveryName" />
      <van-cell title="上次送货人电话" :value="userData.deliveryTel" />
    </van-cell-group>
    <div class="line-container" ref="line"></div>
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul class="list">
      <li
        class="list-item"
        v-for="item in list"
        :key="item.id"
        @click="$router.push(`/announcementDetail/${item.id}`)"
      >
        <p>{{ item.newsTitle }}</p>
        <div>{{ item.createtime }}</div>
      </li>
    </ul>
    <loading-more
      :finished="finished"
      :showLoadingMore="showLoadingMore"
      :loadingFail="loadingFail"
      :list="list"
      @reload="getList"
    />
  </LayoutUser>
  <!-- 报警器状态 -->
  <AlarmStatus ref="alarmStatusRef" />
  <!-- 报警器告警 -->
  <AlarmAlarm ref="alarmAlarmRef" @alarm-cancel="onAlarmCancel" />
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import { bGlmCustomer, getCustomerStat } from '@/api/user'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useGetData } from '@/hooks/useGetData'
import { useStore } from 'vuex'
import { getUserNewsList } from '@/api/viewGasCylinder'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import {
  getCustomerAlarmStatus,
  getCustomerAlarmEventList
} from '@/api/customer'
import AlarmStatus from '@/views/AlarmStatus'
import AlarmAlarm from '@/views/AlarmAlarm'
import * as echarts from 'echarts'
export default {
  name: 'UserHome',
  components: {
    AlarmStatus,
    AlarmAlarm
  },
  setup() {
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const show = ref(false)
    const userData = ref([]) // 用户
    const { getDataLoading, isLoading, showLoading } = useGetDataLoading(
      bGlmCustomer,
      data => {
        store.commit('setCustomer', data)
        userData.value = data
        show.value = true
      },
      companyId.value
    )
    getDataLoading()
    const data = useLoadingMore(getUserNewsList)
    const { getList, list, finished, loadingFail, pageParams } = data
    // 初始化list
    const init = () => {
      list.value = []
      pageParams.page = 1
      pageParams.pageNum = 15
      pageParams.companyId = companyId.value
      finished.value = false
      loadingFail.value = false
      getList()
    }
    init()
    const line = ref(null)
    const xAxis = ref([])
    const yMonAvg = ref([])
    const yYearAvg = ref([])
    const yDayAvg = ref([])
    onMounted(() => {
      const chart = echarts.init(line.value)
      const getCompanyInfo = useGetData(getCustomerStat, data => {
        xAxis.value = data.xaxis
        yDayAvg.value = data.ydayAvg
        yMonAvg.value = data.ymonAvg
        yYearAvg.value = data.yyearAvg
        chart.setOption({
          title: {
            text: ''
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '10%',
            right: '10%',
            bottom: '5%'
          },
          xAxis: {
            type: 'category',
            data: xAxis.value
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '日均使用量',
              type: 'line',
              data: yDayAvg.value
            },
            {
              name: '30日均使用量',
              type: 'line',
              data: yMonAvg.value
            },
            {
              name: '年均使用量',
              type: 'line',
              data: yYearAvg.value
            }
          ]
        })
      })
      getCompanyInfo(companyId.value)
    })
    // 报警器
    const alarmStatusRef = ref(null)
    const alarmAlarmRef = ref(null)
    const itemId = ref('')
    const itemType = ref('')
    const alarmStatusData = ref({})
    const btnLoading = ref(false)
    // 报警器状态
    const handleAlarmStatusClick = () => {
      btnLoading.value = true
      itemType.value = 'status'
      getCustomerAlarmStatus({ userId: userData.value.userId })
        .then((res) => {
          alarmStatusData.value = res.data
          alarmStatusRef.value.showPopup(res.data)
          btnLoading.value = false
        })
        .catch(() => {
          btnLoading.value = false
        })
    }
    // 报警器告警
    const handleAlarmAlarmClick = () => {
      btnLoading.value = true
      itemType.value = 'alarm'
      getCustomerAlarmEventList({ userId: userData.value.userId })
        .then((res) => {
          alarmStatusData.value = res.data
          alarmAlarmRef.value.showPopup(res.data)
          btnLoading.value = false
        })
        .catch(() => {
          btnLoading.value = false
        })
    }
    // 解除警告
    const onAlarmCancel = () => {
      getDataLoading()
    }
    return {
      getDataLoading,
      isLoading,
      showLoading,
      line,
      xAxis,
      yMonAvg,
      yYearAvg,
      yDayAvg,
      ...data,
      list,
      show,
      userData,
      alarmStatusRef,
      alarmAlarmRef,
      handleAlarmStatusClick,
      itemId,
      itemType,
      alarmStatusData,
      btnLoading,
      handleAlarmAlarmClick,
      onAlarmCancel
    }
  }
}
</script>

<style lang="scss" scoped>
  .van-badge__wrapper {
    display: block;
  }
  .image-container {
    background-color: #abcdef;
    height: 210px;
  }
  .line-container {
    padding-top: 10px;
    background-color: #fff;
    margin-top: 16px;
    height: 230px;
  }
  .list {
    font-size: 14px;
    padding: 0 16px;
    line-height: 22px;
    .list-item {
      padding: 10px;
      background-color: #fff;
      margin-top: 10px;
      p {
        margin: 0;
        color: #333;
      }
      div {
        font-size: 12px;
        color: #666;
      }
    }
  }
</style>
